// @ts-nocheck
/* eslint-disable */
export const boldArrowUpCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M7.8 1.334C4.212 1.334 1.3 4.32 1.3 8s2.912 6.667 6.5 6.667S14.3 11.68 14.3 8s-2.912-6.666-6.5-6.666m2.294 6.686a.476.476 0 0 1-.689 0L8.287 6.874v3.46c0 .273-.22.5-.487.5a.497.497 0 0 1-.488-.5v-3.46L6.194 8.02a.48.48 0 0 1-.689 0 .51.51 0 0 1 0-.706l1.95-2a.48.48 0 0 1 .69 0l1.95 2a.51.51 0 0 1 0 .706"/></svg>`,
    name: 'bold-arrow-up-circle' as const
};